import React from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from './context/LanguageContext';
import { CookieProvider } from './context/CookieContext';
import CookieBanner from './components/CookieBanner';
import HomePage from './pages/HomePage';
import PrivacyPage from './pages/PrivacyPage';
import CookiesPage from './pages/CookiesPage';

function App() {
  return (
    <LanguageProvider>
      <CookieProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/cookies" element={<CookiesPage />} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
      </CookieProvider>
    </LanguageProvider>
  );
}

export default App;